import React from "react";
import { Phone, MapPin, Clock } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";

export const ContactHours = () => {
  const { t } = useLanguage();
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 px-6 md:px-12 bg-[#FDFBF7]"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-8">
        <div
          data-testid="hours-card"
          className="bg-white border border-earth p-10 hover-lift"
        >
          <div className="flex items-center gap-3">
            <Clock className="h-5 w-5 text-[#2A5A3B]" />
            <span className="text-[11px] uppercase tracking-[0.25em] font-bold text-[#2A5A3B]">
              {t.hours.overline}
            </span>
          </div>
          <h3 className="mt-4 font-display text-2xl sm:text-3xl font-medium text-[#1C1C1C] tracking-tight">
            {t.hours.title}
          </h3>
          <ul className="mt-8 divide-y divide-[#E5E0D8]">
            {t.hours.rows.map(([day, hours], i) => (
              <li
                key={i}
                data-testid={`hours-row-${i}`}
                className="flex items-center justify-between py-4"
              >
                <span className="font-medium text-[#1C1C1C]">{day}</span>
                <span
                  className={
                    hours === "Closed" || hours === "Fermé"
                      ? "text-[#C05C3F] font-medium"
                      : "text-muted-foreground"
                  }
                >
                  {hours}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <div
          data-testid="contact-card"
          className="bg-[#2A5A3B] text-white p-10 hover-lift"
        >
          <span className="text-[11px] uppercase tracking-[0.25em] font-bold text-[#E8A58B]">
            {t.contact.overline}
          </span>
          <h3 className="mt-4 font-display text-2xl sm:text-3xl font-medium tracking-tight">
            {t.contact.title}
          </h3>
          <div className="mt-10 space-y-7">
            <div className="flex items-start gap-4">
              <Phone className="h-5 w-5 mt-0.5 text-[#E8A58B]" />
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-white/60">
                  {t.contact.phoneLabel}
                </p>
                <a
                  href="tel:+14388743855"
                  data-testid="contact-phone-link"
                  className="mt-1 block font-display text-xl hover:text-[#E8A58B] transition-colors"
                >
                  {t.contact.phone}
                </a>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <MapPin className="h-5 w-5 mt-0.5 text-[#E8A58B]" />
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-white/60">
                  {t.contact.addressLabel}
                </p>
                <a
                  href="https://www.google.com/maps/search/?api=1&query=2900+Chem.+de+la+Côte-de-Liesse,+Mont-Royal,+QC+H4N+2P2"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="contact-address-link"
                  className="mt-1 block text-base leading-relaxed hover:text-[#E8A58B] transition-colors"
                >
                  {t.contact.address}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
